import {ChangeDetectionStrategy, Component} from "@angular/core";

import {AnimationOptions, LottieComponent} from "ngx-lottie";

@Component({
  selector: "app-receiver-placeholder",
  standalone: true,
  imports: [LottieComponent],
  templateUrl: "./receiver-placeholder.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiverPlaceholderComponent {
  public readonly lottieGlobe: AnimationOptions = {
    path: "/assets/lottie/globe.json",
    loop: true,
    autoplay: true
  };
}
